import { inject, Injectable } from '@angular/core';
import { SupabaseClient } from '@supabase/supabase-js';
import { SUPABASE } from '../app.config';
import { DatabaseService } from './database.service';

@Injectable({
  providedIn: 'root'
})
export class SupabaseDatabaseService<T> implements DatabaseService<T> {

  protected supabase: SupabaseClient = inject(SUPABASE);

  constructor() {}

  async create<T>(tableName: string, record: Partial<T>): Promise<T> {
    const { data, error } = await this.supabase
      .from(tableName)
      .insert([record])
      .select()
      .single();

    if (error) {
      console.error(`Erro ao criar em '${tableName}':`, error);
      throw new Error(error.message);
    }
    return data as T;
  }

  async getAll<T>(tableName: string): Promise<T[]> {
    const { data, error } = await this.supabase
      .from(tableName)
      .select('*');

    if (error) {
      console.error(`Erro ao buscar todos em '${tableName}':`, error);
      throw new Error(error.message);
    }
    return (data as T[]) || [];
  }

  async getById<T>(tableName: string, id: number | string): Promise<T | null> {
    const { data, error } = await this.supabase
      .from(tableName)
      .select('*')
      .eq('id', id)
      .maybeSingle();

    if (error) {
      // O código 'PGRST116' indica que nenhuma linha foi encontrada, o que não é um erro de fato.
      if (error.code === 'PGRST116') {
        return null;
      }
      console.error(`Erro ao buscar por ID em '${tableName}':`, error);
      throw new Error(error.message);
    }
    return data as T;
  }

  async update<T>(tableName: string, id: number | string, updates: Partial<T>): Promise<T> {
    const { data, error } = await this.supabase
      .from(tableName)
      .update(updates)
      .eq('id', id)
      .select()
      .single();

    if (error) {
      console.error(`Erro ao atualizar em '${tableName}':`, error);
      throw new Error(error.message);
    }
    return data as T;
  }

  async delete(tableName: string, id: number | string): Promise<void> {
    const { error } = await this.supabase
      .from(tableName)
      .delete()
      .eq('id', id);

    if (error) {
      console.error(`Erro ao deletar em '${tableName}':`, error);
      throw new Error(error.message);
    }
  }
}